import { queryOptions } from '@tanstack/react-query';
import { fetchRoleplays } from './roleplays.ts';

/** Every practice conversation the reader can see, for the route loader and the practice page alike. */
export function roleplaysQuery() {
  return queryOptions({
    queryKey: ['roleplays'],
    queryFn: fetchRoleplays,
  });
}
